import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DocumentsFilter } from '../../common/types/types';

interface documentsFilterState {
  reachedDocumentsFilter: DocumentsFilter;
}

const initialState: documentsFilterState = {
  reachedDocumentsFilter: {
    tabStatus: 0,
    tabText: 'All',
    date: undefined,
    search: '',
  },
};

const documentsFilterSlice = createSlice({
  name: 'documentsFilter',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setReachedDocumentsFilter: (state, action: PayloadAction<DocumentsFilter>) => {
      return { ...state, reachedDocumentsFilter: action.payload };
    },
  },
});

export const { reset, setReachedDocumentsFilter } = documentsFilterSlice.actions;
export default documentsFilterSlice.reducer;
